import { GridDataResult } from '../shared/grid/grid.model';
import { LabelValueLower } from './keyvalue';
import { ILazyComponentHandler, SmartActionContext } from './smart-actions.models';


export interface IProcessInstanceListRequest {
    processViewId: number;
    pageNumber: number;
    pageCount: number;
    processViewFilters?: IProcessInstanceListFilter[];
    metaData: any;
    [key: string]: any;
}

export interface IProcessInstanceListFilter {
    columnName:string;
    filterValue: any;
}

export const Genders: LabelValueLower[] = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Unknown', value: 'unknown' }
];


/***********************Process Manager Paging******************************** */

export interface IProcessInstanceCheckoutRequest {
    processViewId: number;
    metaData: any;
}

export interface ICheckOutMetaData {
    viewFilters: any;
}

export class ProcessManagerPageResult extends GridDataResult<IProcessInstanceListItem> {
    data: IProcessInstanceListItem[];
    totalCount: number;
    pageCount: number;

    constructor(input: Partial<ProcessManagerPageResult>) {
        super();
        Object.assign(this, input);
        this.items = this.data;
    }

    getItems() {
        return this.data;
    }

    getFilteredCount() {
        return this.totalCount;
    }
}

export interface IProgressManagerListResponse {
    id: number;
    owner: string;
    firstName: string;
    lastName: string;
    number: string;
    state: string;
    stage: string;
    stageCreatedBy: string;
    stageCreatedOn: Date;
    lockStatus: string;
    lockStatusCreatedBy: string;
    lockStatusCreatedOn: Date;
    identityId: number;
    shardName: string;
}

export interface ISelectedProcessView {
    view: IProcessView,
    // metadata?: any;
}

export interface IProcessView {
    id: number;
    processTypeId: number;
    targetComponent: string;
    workflowId: string;
    displayName: string;
    adGroup: string;
    metadata: IProcessComponentSettings
    isSuperUser: boolean;
    totalCount: number;
}
class ProcessView implements IProcessView {
    id: number;
    processTypeId: number;
    targetComponent: string;
    workflowId: string;
    displayName: string;
    adGroup: string;
    metadata: IProcessComponentSettings;
    isSuperUser: boolean;
    private _totalCount: number;

    constructor(
        id: number,
        processTypeId: number,
        targetComponent: string,
        workflowId: string,
        displayName: string,
        adGroup: string,
        metadata: IProcessComponentSettings,
        isSuperUser: boolean,
        totalCount: number
    ) {
        this.id = id;
        this.processTypeId = processTypeId;
        this.targetComponent = targetComponent;
        this.workflowId = workflowId;
        this.displayName = displayName;
        this.adGroup = adGroup;
        this.metadata = metadata;
        this.isSuperUser = isSuperUser;
        this._totalCount = totalCount;
    }

    get totalCount(): number {
        return this._totalCount;
    }

    set totalCount(value: number) {
        this._totalCount = value;
    }
}
export interface IProcessComponentSettings {
    name: string;
    openBrowserTab?: boolean;
    route?: string;
    disableTakenByMe?: boolean;
    autoAssignUser?: boolean;
    storedProcedure?: string;
    containerName?: string;
}

export interface ISourceProcessAction {
    displayName?: string,
    description?: string,
    icon?: string,
    uiComponent: IProcessComponentSettings
}


export interface IProcessTaskConfig {
    item: IProcessInstanceItem;
    sourceProcessAction?: ISourceProcessAction;
    selectedProcessView: ISelectedProcessView;
    componentHandler?: ILazyComponentHandler;
    profiles?: any[];
}

export interface ProcessInstanceData {
    processTypeId: number;
    entityId: string;
    entityTypeId: number;
    memberId: string;
    owner: string;
    tenantName: string;
}

export interface IProcessInstanceMetadata {
    view: IProcessView,
    currentActionConfig: IProcessTaskConfig,
    // wrapper?: ProcessViewWrapperComponent
}

export interface IProcessAction {
    workflowId: string;
    action: string;
    stage?: string;
    processInstanceId: string;
    tenantName: string;
    metaData: any;
    processInstanceData?: ProcessInstanceData
}

export interface IInsertProcessActionResponse {
    processInstanceId: string;
    errorMessage: string;
}

export interface IViewStatusRequest {
    processViewId: number;
    metaData: any;
}
export interface IViewStatusResponse {
    totalCount: number;
}


export interface ICheckoutSingleItemResponse {
    data: IProcessInstanceItem;
    errorMessage: string;
}


export interface IProcessInstanceListItem extends IProcessInstanceItem {
    identityId: number;
    createdOn: Date;
    smartActions?: SmartActionContext;
}

export interface IProcessInstanceItem {
    comments: string;
    createdOn: Date;
    entityId: string;
    entityTypeId: number;
    id: string;
    firstName: string;
    lastName: string;
    lockStatus: string;
    lockStatusCreatedBy: string;
    lockStatusCreatedOn: Date;
    memberId: string;
    number: string;
    owner: string;
    shardName: string;
    tenantId?: string;
    state: string;
    stage: string;
    stageCreatedBy: string;
    stageCreatedOn: Date;
    base64: string;
    metaData: any;
    version?: number;
}

export interface IProcessInstanceResponseItem {
    id: string,
    processViewId: number,
    entityId: string,
    entityTypeId: number,
    memberId: string,
    status: string,
    owner: string,
    metadata: any,
    createdOn: Date,
    lastModifiedOn: Date,
    tenantId: string,
    configId: number,
    messageId: string
}

export interface ICheckoutItemResponse {
    instance : IProcessInstanceResponseItem;
    error : string;
}
export interface IMessageCount {
    viewName?: string;
    activeMessageCount?: number;
    deadLetterMessageCount?: number;
    scheduledMessageCount?: number;
    transferMessageCount?: number;
    transferDeadLetterMessageCount?: number;
}
